import React, { useEffect, useRef } from 'react';
import NetworkRestrictionPage from '../../components/NetworkRestrictionPage';
import useNetworkRestriction from '../../hooks/useNetworkRestriction';
import useAnalytics from '../../hooks/useAnalytics';
import { config } from '../../config/awsExports';

// useAnalytics.js is untyped and infers every field as required.
interface AnalyticsEvent {
  event: string;
  sectionId?: string;
  extraParams?: Record<string, string>;
}

const NetworkRestriction = () => {
  const { isChecking, retryFailed, retry } = useNetworkRestriction({ enabled: true });
  const { setAnalytics } = useAnalytics() as { setAnalytics: (event: AnalyticsEvent) => Promise<void> };
  const sectionLoadedSent = useRef(false);

  // setAnalytics changes identity on every render, so a ref keeps this to once per mount.
  useEffect(() => {
    if (sectionLoadedSent.current) return;
    sectionLoadedSent.current = true;
    setAnalytics({ event: 'section_loaded', sectionId: 'network-restriction' });
  }, [setAnalytics]);

  const handleRetry = () => {
    setAnalytics({ event: 'button_clicked', extraParams: { name: 'network-restriction-retry' } });
    retry();
  };

  const handleFormOpen = () => {
    setAnalytics({ event: 'button_clicked', extraParams: { name: 'network-restriction-form-open' } });
  };

  return (
    <NetworkRestrictionPage
      formUrl={config.env.networkAccessRequestFormUrl}
      onRetry={handleRetry}
      isRetrying={isChecking}
      retryFailed={retryFailed}
      onFormOpen={handleFormOpen}
    />
  );
};

export default NetworkRestriction;
